// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.48047 2.5L9.78125 2.875L12.6807 6.5H23V21H1V2.5H9.48047Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 2.5V4.5H13V2.5H23Z"}}]};

const PageTabFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'page-tab-filled',
    ref,
    icon: element,
  },
));

PageTabFilledIcon.displayName = 'PageTabFilledIcon';

export default PageTabFilledIcon;
